export const INDEX_REPO = 'https://github.com/StreamNook/streamnook-plugins';
export const PUBLISHING_URL = `${INDEX_REPO}/blob/main/PUBLISHING.md`;
// The frozen spec ships with the StreamNook source; these paths go live when
// the modular-architecture branch lands on main.
const SPEC_BASE = 'https://github.com/StreamNook/StreamNook/blob/main/docs/plugins';
export const SPEC = {
  readme: `${SPEC_BASE}/README.md`,
  protocol: `${SPEC_BASE}/PROTOCOL.md`,
  manifest: `${SPEC_BASE}/MANIFEST.md`,
  capabilities: `${SPEC_BASE}/CAPABILITIES.md`,
  signing: `${SPEC_BASE}/SIGNING.md`,
  official: `${SPEC_BASE}/OFFICIAL.md`,
};
